module.exports = __webpack_public_path__ + "img/点击查看交互式媒体.png";